<template>
    <div
        class="text-input"
        :class="{
            'has-focus': hasFocus,
            'has-value': hasValue,
            'has-loading': hasFocus && items === 'search'
        }"
    >
        <outside-click-detector @outside="hideList">
            <label
                class="text-input__label"
                :for="id"
            >{{ labelText }}</label>
            <template v-if="fieldType === 'textarea'">
                <textarea
                    class="text-input__field text-input__field--autoheight"
                    rows="1"
                    ref="textarea"
                    :name="name"
                    :id="id"
                    :readonly="readonly"
                    :disabled="disabled"
                    :value="value | html_entity_decode"
                    :autocomplete="$attrs.autocomplete || 'autocomplete'"
                    @focus="onFocus"
                    @blur="onBlur"
                    @input="onInput"
                    @paste="onPaste"
                    @keydown.up.prevent="selectPrevItem"
                    @keydown.down.prevent="selectNextItem"
                    @keydown.enter.prevent="selectItemByIndex(currentItemIndex)"
                    @keydown.esc.prevent="hideList"
                    :data-mask="mask"
                    v-autogrow
                >
            </textarea>
            </template>
            <template v-else>
                <input
                    ref="field"
                    class="text-input__field"
                    type="text"
                    :name="name"
                    :id="id"
                    :value="value | html_entity_decode"
                    :readonly="readonly"
                    :disabled="disabled"
                    :autocomplete="$attrs.autocomplete || 'autocomplete'"
                    @focus="onFocus"
                    @blur="onBlur"
                    @input="onInput"
                    @paste="onPaste"
                    @keydown.up.prevent="selectPrevItem"
                    @keydown.down.prevent="selectNextItem"
                    @keydown.enter.prevent="selectItemByIndex(currentItemIndex)"
                    @keydown.esc.prevent="hideList"
                    :data-mask="mask"
                >
            </template>
            <button
                class="text-input__clear"
                type="button"
                tabindex="-1"
                v-if="clearable && hasValue && !readonly && !disabled"
                @click="clear"
            >
                <svg><use xlink:href="/sprite.svg#icon-close"></use></svg>
            </button>
            <div
                class="text-input__status" :data-error="statusError"
                v-if="statusText"
            >
                {{ statusText }}
            </div>
            <div class="select-input__option-list-wrap" v-if="isListVisible && items !== 'search' && items.length">
                <ul class="select-input__option-list">
                    <li class="select-input__option"
                        v-for="(item, index) in sortedItems"
                        :key="index"
                        :class="{ 'selected': currentItemIndex === index }"
                        @click="selectItem(item)"
                    >
                        {{ itemValueKey ? item[itemValueKey] : item }}
                    </li>
                </ul>
            </div>
        </outside-click-detector>
    </div>
</template>

<script>
import { initMaskFields } from '../../../modules/mask';
import OutsideClickDetector from '../../dom-helpers/outside-click-detector';

export default {
    name: 'text-input-suggest',
    components: { OutsideClickDetector },
    props: {
        id: {
            required: false,
            type: String,
        },
        name: {
            required: true,
            type: String,
        },
        label: {
            required: true,
            type: String,
        },
        type: {
            required: false,
            type: String,
            default: 'text',
        },
        value: {
            required: false,
            type: String,
        },
        status: {
            required: false,
            type: String,
        },
        mask: {
            required: false,
            type: String,
        },
        readonly: {
            required: false,
            type: Boolean,
        },
        disabled: {
            required: false,
            type: Boolean,
        },
        placeholder: {
            required: false,
            type: String,
        },
        clearable: {
            required: false,
            type: Boolean,
            default: true,
        },
        hint: {
            required: false,
            type: String,
        },
        items: {
            default: [],
        },
        itemValueKey: {
            required: false,
            type: String,
        },
        fieldType: {
            default: 'input',
        },
    },

    data() {
        return {
            hasFocus: false,
            isListVisible: false,
            currentItemIndex: 0,
        };
    },

    computed: {
        statusError(){
            let lable = this.labelText;
            if(lable.search('адрес') !== -1){
                lable = 'Aдрес';
            }

            let status = this.status ? this.status.replace('Поле', 'Поле '+ lable) : '';
            let hint = this.hint ? this.hint.replace('Поле', 'Поле '+ lable) : '';
            return this.valid ? "" : (status || hint);
        },
        hasValue() {
            return !!this.value;
        },
        labelText() {
            return this.placeholder && !this.hasValue ? this.placeholder : this.label;
        },
        statusText() {
            console.log('status', this.status || this.hint);
            return this.status || this.hint;
        },
        isFirstItem() {
            return this.currentItemIndex === 0;
        },
        isLastItem() {
            return this.currentItemIndex === this.sortedItems.length - 1;
        },
        sortedItems() {
            const { items } = this;
            const key = this.itemValueKey;

            return key && Array.isArray(items) ? items.sort((a, b) => a[key].localeCompare(b[key])) : items.sort();
        },
    },

    mounted() {
        this.$nextTick(() => {
            initMaskFields();
        });
    },

    methods: {
        onFocus(e) {
            this.hasFocus = true;
            this.$emit('focus', e.target.value);
            this.showList();
        },

        onBlur() {
            this.hasFocus = false;
        },

        onInput(e) {
            this.showList();
            this.$emit('input', e.target.value);
        },

        onPaste(e) {
            this.$emit('input', e.target.value);
        },

        selectItem(item) {
            this.hideList();
            this.$emit('select', item);

            this.$emit('input', this.itemValueKey ? item[this.itemValueKey] : item);
        },

        selectItemByIndex(index) {
            this.selectItem(this.sortedItems[index]);
        },

        selectPrevItem() {
            if (this.isListVisible && !this.isFirstItem) {
                this.currentItemIndex -= 1;
            }
        },

        selectNextItem() {
            if (this.isListVisible && !this.isLastItem) {
                this.currentItemIndex += 1;
            }
        },

        showList() {
            this.isListVisible = true;
        },

        hideList() {
            this.isListVisible = false;
        },

        toggleListVisibility() {
            if (this.isListVisible) {
                this.hideList();
            } else {
                this.showList();
            }
        },

        clear() {
            this.$emit('input', '');
        },
    },

    watch: {
        value() {
            if (this.fieldType === 'textarea') {
                this.$nextTick(() => {
                    this.$refs.textarea.dispatchEvent(new Event('input'));
                });
            }
        },
    },
};
</script>
